module.exports = __webpack_public_path__ + "static/media/vip-entry-locked.50a7e86b.png";